<template>
  <div v-if="!loading" class="comment-tab">
    <div class="footer-bar">
      <VacancyMessageArea
        @editComment="editComment"
        @leaveComment="addComment"
        :editMode="editMode"
        :commentToEdit="commentToEdit"
        :error="editorError"
        class="comment-input-area"
      />
    </div>
    <div class="comment-tab__center">
      <CommentList
        ref="messageArea"
        :commentList="comments"
        @editComment="prepareComment"
        @deleteComment="deleteComment"
        :userId="userId"
        :mode="mode"
      />
    </div>
  </div>
</template>
<script>
import { store } from '@/store';
import { ACTION, MODULE, EVENTBUS_EVENTS } from '@/utils/constants';
import { dialogMixin, errorMsg, mixin } from '@/utils/mixins';
import CommentList from 'Elements/Comment/CommentList';
import { eventBus } from '@/bus';
import VacancyMessageArea from 'Elements/Sidebar/VacancyMessageArea';

export default {
  mixins: [mixin, dialogMixin, errorMsg],
  components: {
    VacancyMessageArea,
    CommentList
  },
  props: {
    module: String,
    id: String,
    userId: String,
    tableSql: String,
    mode: {
      type: String,
      default: 'default'
    },
    countId: String,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commentToEdit: {},
      editorError: false,
      storeModule: this.mode == 'selection' ? 'selectionPanel' : 'subpanels',
      editMode: ''
    };
  },
  created() {
    eventBus.$on(
      EVENTBUS_EVENTS.CONFIRM_COMMENT_DELETION,
      this.confirmCommentDeletion
    );
  },
  beforeDestroy() {
    //TODO: если переходим на другую сабпанель, то очищаем роут с комментарием
    if (
      this.$router.currentRoute.name.includes('commentId') &&
      this.$router.currentRoute.path.includes('/comment')
    ) {
      this.$router.push(this.$router.currentRoute.path.split('/comment')[0]);
    }

    store.commit(`subpanels/clearActiveSubpanelData`, 'comments');
    eventBus.$off(
      EVENTBUS_EVENTS.CONFIRM_COMMENT_DELETION,
      this.confirmCommentDeletion
    );
  },
  computed: {
    is_visible() {
      return store.state.common.visible_dialog;
    },
    comments() {
      return this.mode == 'selection'
        ? store.state.selectionPanel.candidates[this.countId].comments
        : store.state.subpanels.comments;
    },
    commentForm() {
      return this.mode == 'selection'
        ? store.state.selectionPanel.candidates[this.countId].commentFormActive
        : store.state.subpanels.commentFormActive;
    },
    loadCommentsIntent() {
      return store.state.subpanels.activeSubpanel[this.module].intents[0];
    }
  },
  methods: {
    addComment({ comment, to_recruits }) {
      if (!comment.content) {
        this.editorError = true;

        return;
      }

      this.editorError = false;

      this.saveComment(comment, to_recruits, false);
    },
    closeCommentDialog() {
      store.commit('common/setVisibleDialog', {
        name: 'comment_dialog',
        val: false
      });
    },
    prepareComment(comment) {
      this.commentToEdit = comment;
      this.showCommentForm({ flag: true, comment });
    },
    editComment({ comment, to_recruits }) {
      if (!comment.content) {
        this.editorError = true;
        return;
      }

      this.editorError = false;

      this.commentToEdit = {};

      this.saveComment(comment, to_recruits, true);
    },
    async updateCommentsList() {
      this.$emit('set-loading', true);
      try {
        await store.dispatch(
          `${this.storeModule}/loadComments`,
          this.loadCommentsIntent
        );
      } catch (err) {
        this.catchError(
          err,
          'Возникла ошибка загрузки списка комментариев',
          'comments loading'
        );
      } finally {
        this.$emit('set-loading', false);
      }
    },
    showCommentForm({ flag, comment = null }) {
      this.editedComment = comment;
      store.commit(`${this.storeModule}/setCommentForm`, flag);

      if (!this.$refs?.messageArea?.$parent?.$parent?.$el) return;
      const list = this.$refs.messageArea.$parent.$parent.$el;
      list.scrollTo({
        top: list.scrollHeight,
        behavior: 'smooth'
      });

      // универсальный селектор для прокручиваемого контента страницы, как у кандидата
      const contentEl = document.querySelector('.scrollable-content');
      if (!contentEl) return;
      contentEl.scrollTo({
        top: contentEl.scrollHeight,
        behavior: 'smooth'
      });
    },
    async saveComment(comment, to_recruits, edit) {
      store.commit(`${this.storeModule}/setCommentForm`, false);
      this.$emit('set-loading', true);

      const formData = new FormData();
      formData.set('module', MODULE.HRPAC_COMMENTS);
      formData.set('record', edit ? comment.id : '');
      formData.set('action', ACTION.SAVE);
      formData.set('relate_to', this.tableSql);
      formData.set('relate_id', this.id);
      formData.set('parent_type', this.module);
      formData.set('parent_id', this.id);
      formData.set('assigned_user_id', this.userId);
      formData.set(
        'to_recruits',
        to_recruits !== undefined
          ? to_recruits
          : comment.access_role
          ? JSON.parse(comment.access_role).to_recruits
          : false
      );
      formData.set('text', comment.content);

      formData.set('jsqon_return', false);

      try {
        await store.dispatch(`${this.storeModule}/saveComment`, {
          options: formData
        });
      } catch (err) {
        this.catchError(
          err,
          'Возникла ошибка при сохранении комментария',
          'save comment'
        );
      } finally {
        this.$emit('set-loading', false);
        this.updateCommentsList();
      }
    },
    deleteComment(comment) {
      store.commit(`${this.storeModule}/setCommentToDelete`, comment);
      store.commit('common/setVisibleDialog', {
        name: 'comment_dialog',
        val: true
      });
    },
    async confirmCommentDeletion() {
      this.setVisibleDialog('comment_dialog', false);

      const comment = store.state.subpanels.commentToDelete;

      if (!comment) return;

      const options = new FormData();

      options.set('module', MODULE.HRPAC_COMMENTS);
      options.set('record', comment.id);
      options.set('action', ACTION.DELETE);

      try {
        await store.dispatch('subpanels/confirmDeleteComment', {
          options
        });

        try {
          store.commit('subpanels/setCommentToDelete', null);
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка при удалении комментария',
            'comment remove'
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.updateCommentsList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  &-center {
    overflow-y: auto;
    height: 100%;
    -ms-overflow-style: none;

    &.content-collapsed {
      max-height: calc(100% - 200px);
    }
  }

  &-bottom {
    & ::v-deep .message__area {
      border-bottom: none;
      padding: 8px 0 0 0;

      &-checkbox {
        margin: 8px 0 0 0;
      }
    }
  }
}

.comment {
  &-tab {
    position: relative;
    border-radius: 4px;
    height: 100%;
    width: 100%;

    &__center {
      // overflow: hidden;
      background: $white;
      padding: 24px;
      // max-height: 717px;
      overflow-y: auto;
      border-radius: 4px 4px 0 0;
    }
  }

  &-input-area {
    & ::v-deep .el-textarea__inner {
      padding: 7px 12px !important;
    }
  }
}

.footer-bar {
  align-content: center;
  display: flex;
  justify-content: center;
  vertical-align: middle;
  border-bottom: 1px solid $grey8;
  border-radius: 0 0 4px 4px;
  padding: 24px;
  box-sizing: border-box;
  background-color: $white;
  width: 100%;
  bottom: 0;
}
</style>
